import { BaseScript } from '../BaseScript';
import BaseViewModel from '../../../Models/BaseViewModel';
import { ScriptDescriptionType } from 'src/Modules/DynamicForm/Types';

export class SelectDictDataScript extends BaseScript {
	path: string | null = null;
	attrName: string | null = null;

	constructor(
		contextElement: BaseViewModel,
		script: ScriptDescriptionType,
		scriptPurpose: string,
	) {
		// 	Вызов конструктора родителя.
		super(contextElement, script, scriptPurpose);

		const matches = this.Content?.match(
			/SelectDictData: AttrName:([^<>]*) Path:([^<>]*)/,
		);
		if (matches && matches.length === 3) {
			this.attrName = matches[1];
			this.path = matches[2];
		}
	}

	getDependentFields = () => {
		return [this.path ?? ''];
	};

	/** Запустить скрипт в контексте hostObject */
	runScript = () => {
		if (!this.Content) {
			return null;
		}
		try {
			return this.runSelectDictDataScript();
		} catch (e: any) {
			console.warn(e.message);
		}
		return null;
	};

	runSelectDictDataScript = () => {
		const viewModel = this.contextElement.getViewModelByPath(this.path!);
		if (viewModel.Value === null || viewModel.Value === undefined) {
			return null;
		}
		const value = viewModel.Value;
		if (
			viewModel.elementDescriptor.DescriptorKey ===
			'DictionaryRegistryControlDescriptor'
		) {
			const items: Array<any> = []; // viewModel.metaData();
			const item = items.find((i) => {
				return i.id === value;
			});
			// ko.utils.arrayFirst(items, function (item) {
			// 	return item.id === value;
			// });
			return item.metaData[this.attrName!];
		}
		console.warn('enumTitle not found');
		console.groupCollapsed(
			'EnumTitleScript - enumTitle not found - ' + this.path,
		);
		console.log('viewModel ', viewModel);
		console.log('value ', value);
		console.groupEnd();
		return null;
	};
}
